<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <vs-table :max-items="5" pagination :data="closedUserData" search>
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.GroupsDetails") }}
              </div>

              <span class="vx-col order-1">
                <vs-button icon-pack="feather" @click="handleAddGroup" size="small">
                  {{ $t("setup.label.AddGroup") }}</vs-button
                >
              </span>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.GroupName") }}</vs-th>
              <vs-th>{{ $t("setup.label.GroupAddress") }}</vs-th>
              <vs-th>{{ $t("setup.label.CountNo's") }}</vs-th>
              <vs-th>{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(uploads, index) in data">
                <vs-td :data="uploads.groupName">{{ uploads.groupName }}</vs-td>
                <vs-td :data="uploads.groupAddress">{{ uploads.groupAddress }}</vs-td>
                <vs-td :data="uploads.countNo">{{ uploads.countNo }}</vs-td>
                <vs-td>
                  <feather-icon
                    icon="PlayIcon"
                    :title="$t('setup.label.ReProcess')"
                    class="text-warning"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                    @click.stop="editUserData(uploads)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.AddGroup')"
              :active.sync="bulkUploadsPopup"
              class="popup-close"
            >
              <ValidationObserver ref="observer">
                <form>
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.GroupName')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.GroupName')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="createClosedUser.groupName"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.GroupAddress')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.GroupAddress')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="createClosedUser.groupAddress"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <h5>{{ $t("setup.label.AdditionalInformation") }}</h5>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label"></div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.GroupCIR')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.GroupCIR')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="createClosedUser.attribute1"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.DIR')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.DIR')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="createClosedUser.attribute2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.MemberCIR')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.MemberCIR')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="createClosedUser.attribute3"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.DIR')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.DIR')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="createClosedUser.attribute4"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>

                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        style="margin-left: 220px"
                        type="border"
                        @click="bulkUploadsPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button @click="createUser">{{
                        $t("setup.label.Save")
                      }}</vs-button>
                    </span>
                  </div>
                </form>
              </ValidationObserver>
            </vs-popup>
          </div>
          <validation-popup
            :errorMessage="errorMessage"
            :warningPopup="warningPopup"
            :warningText="warningText"
            @closeWarning="warningPopup = false"
          ></validation-popup>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const closedUserObj = {
  groupAddress: "",
  groupName: "",
  attribute1: "",
  attribute2: "",
  attribute3: "",
  attribute4: "",
};
export default {
  data() {
    return {
      resetKey: 0,
      loading: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      editableId: "",
      bulkUploadsPopup: false,
      reprocessPopup: false,
      paymentEditPopup: false,
      createClosedUser: { ...closedUserObj },
      createdpop: {},
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    closedUserData() {
      return this.$store.getters["closedUserGroup/GetClosedUserList"];
    },
  },
  methods: {
    async getDataUploads() {
      this.loading = true;
      try {
        this.$store.dispatch("closedUserGroup/setClosedUserGroup");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    handleAddGroup() {
      this.resetKey++;
      this.bulkUploadsPopup = true;
    },
    async createUser() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        await this.$store.dispatch("closedUserGroup/createClosedUserStatement", {
          data: this.createClosedUser,
        });
        this.bulkUploadsPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Statement Created Successfully!",
          type: "success",
        });
        this.getDataUploads();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
  },
  created() {
    this.getDataUploads();
  },
};
</script>
